import { useRouteMatch } from "react-router";
import en from './en'
import es from './es'

const languages = {
  'en': en,
  'es': es,
}

const Literal = (text) => {
  const match = useRouteMatch()

  let lang = 'en'
  if (match && match.params.lang && (match.params.lang in languages)) {
    lang = match.params.lang
  }

  return languages[lang][text]
}

export default Literal